<template>
  <button
    type="button"
    data-testid="property-type-filters-trigger"
    :disabled="disabled"
    :aria-expanded="expanded"
    :class="[
      'tw-inline-flex tw-w-[188px] tw-rounded-[47px] tw-bg-transparent focus-visible:tw-outline-none max-[375px]:tw-w-[160px] lg:tw-w-auto',
      outerStateClasses,
      disabled ? 'tw-cursor-not-allowed' : 'tw-cursor-pointer',
    ]"
    @click="$emit('toggle')"
  >
    <span
      :class="[
        'tw-font-inter tw-flex tw-h-[36px] tw-w-full tw-items-center tw-justify-center tw-gap-[10px] tw-overflow-hidden tw-text-ellipsis tw-rounded-[30px] tw-px-[16px] tw-py-[8px] tw-text-[16px] tw-font-bold tw-leading-6 max-[375px]:tw-gap-[8px] max-[375px]:tw-px-[8px] max-[375px]:tw-text-[14px] max-[375px]:tw-leading-[20px] lg:tw-h-full lg:tw-gap-[12px] lg:tw-px-[24px] lg:tw-py-0',
        innerStateClasses,
      ]"
    >
      <span class="tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap">
        Property type
      </span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        class="tw-shrink-0 tw-transition-transform"
        :class="{ 'tw-rotate-180': !expanded }"
        aria-hidden="true"
      >
        <path
          d="M14.625 11.25L9 5.625L3.375 11.25"
          stroke="currentColor"
          stroke-width="1.6875"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
  </button>
</template>

<script>
export default {
  name: 'PropertyTypeFiltersTrigger',
  props: {
    expanded: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['toggle'],
  computed: {
    outerStateClasses() {
      if (this.disabled) {
        return 'tw-border-0 tw-bg-transparent tw-p-0 lg:tw-h-[50px]';
      }

      return this.expanded
        ? 'tw-border-2 tw-border-[#0082B8] tw-p-[2px] lg:tw-h-[50px]'
        : 'tw-border tw-border-transparent tw-bg-transparent tw-p-[2px] lg:tw-h-[58px]';
    },
    innerStateClasses() {
      if (this.disabled) {
        return 'tw-border-0 tw-bg-gray-200 tw-text-[#5C6A75] tw-shadow-none';
      }

      if (this.expanded) {
        return 'tw-border tw-border-[#9CA3AF] tw-bg-white tw-text-[#3B4143]';
      }

      return 'tw-border-2 tw-border-gray-200 tw-bg-white tw-text-[#3B4143]';
    },
  },
};
</script>
